import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=1ea949e8&scoped=true"
import script from "./list2.vue?vue&type=script&lang=js"
export * from "./list2.vue?vue&type=script&lang=js"
import style0 from "./list2.vue?vue&type=style&index=0&id=1ea949e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea949e8",
  null
  
)

export default component.exports